import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

/*
  -----> WARNING: THIS IMPORT LOGIC IS INTENTIONAL <------

  Because of how Vite works under the hood, if a file/source exports anything other than
  a component, the hot reload does not properly work to keep the state and causes
  full page/component tree reloads instead
*/

import { AuthProvider } from './Auth/Provider';
import { ChangeOwnerModalProvider } from './OwnershipChange/Provider';
import { ConfirmationProvider } from './Confirmation/ConfirmationProvider';
import { JustificationModalProvider } from './Justification/JustificationProvider';
import { NotificationProvider } from './Notifications/NotificationProvider';
import { OnlineUsersProvider } from './Online/OnlineProvider';
import { PendingActionsCountProvider } from './PendingActions/PendingActionsProvider';
import { ProjectProvider } from './Project/ProjectProvider';
import { RealTimeProvider } from './RealTime/RealTimeProvider';
import { Toaster } from './Toast';
import { WindowSizeProvider } from './WindowSize/WindowSize';
import { TeamProvider } from './Team/Provider';

import ErrorBoundary from '../components/ErrorBoundary';

const queryClient = new QueryClient();

function AppProvider({ children }: { children: ReactNode }) {
  return (
    <BrowserRouter>
      <WindowSizeProvider>
        <ErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <ConfirmationProvider>
              <RealTimeProvider>
                <AuthProvider>
                  <TeamProvider>
                    <OnlineUsersProvider>
                      <ProjectProvider>
                        <PendingActionsCountProvider>
                          <NotificationProvider>
                            <JustificationModalProvider>
                              <ChangeOwnerModalProvider>
                                <>{children}</>

                                <Toaster />
                              </ChangeOwnerModalProvider>
                            </JustificationModalProvider>
                          </NotificationProvider>
                        </PendingActionsCountProvider>
                      </ProjectProvider>
                    </OnlineUsersProvider>
                  </TeamProvider>
                </AuthProvider>
              </RealTimeProvider>
            </ConfirmationProvider>
          </QueryClientProvider>
        </ErrorBoundary>
      </WindowSizeProvider>
    </BrowserRouter>
  );
}

export default AppProvider;
